export enum ContentLabelsEnum {
  OM = 'om',
  METOD = 'metod',
  KOSTNAD = 'kostnad',
  FORDELAR = 'fordelar',
  NACKDELAR = 'nackdelar',
  SYMPTOM = 'symtom',
  ORSAK = 'orsak',
  EGENVARD = 'egenvard',
  BEHANDLING = 'behandling',
  VARDGIVARE = 'vardgivare',
  CUSTOM = 'custom',
}
